export default __webpack_public_path__ + "073b3402d036714b43709614d1da717a.woff";